import styles from "./TimelineFeed.module.scss";
import Grid from "@/components/Grid";
import {
  useRecentPostsQuery,
  useRecentPostsVersion2Query,
} from "@/fetch/social";
import { useInView } from "react-intersection-observer";
import { PostCard } from "@/components/Social";
import { Skeleton } from "@/components/Loader";
import { useEffect, useRef } from "react";
import compact from "lodash/compact";
import Typography from "@/components/Typography";
import { EmptySocialPost } from "@/components/EmptyList";
import { useDialog, useResponsive } from "@/hooks";
import PostDialog from "./PostDialog";
import MobilePostDialog from "./MobilePostDialog";
import MeetOtherTravellerCard from "./MeetOtherTravellerCard";

const postLoader = <Skeleton variant="rectangular" height="180px" />;

const TimelineFeed: React.FC<{ variant: "feed" | "highlight" }> = ({
  variant,
}) => {
  const isFeed = variant === "feed";
  const params = isFeed
    ? {
        pinned: false,
        adminPosts: false,
      }
    : {
        adminPosts: true,
      };
  const {
    data: recentPostsData,
    isFetchingNextPage,
    isLoading: isRecentPostsLoading,
    fetchNextPage,
    hasNextPage,
  } = useRecentPostsQuery(params);
  const { data: pinnedPostsData, isLoading: isPinnedPostsLoading } =
    useRecentPostsQuery({ pinned: true, pageSize: 1 });
  const { ref: loaderContainerRef, inView: isLoaderInView } = useInView({
    threshold: 0,
  });
  const { isOpen: isPostDialogOpen, query } = useDialog("post");
  const { isMobile } = useResponsive();
  const gridRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (
      !isLoaderInView ||
      !hasNextPage ||
      isRecentPostsLoading ||
      isFetchingNextPage
    )
      return;

    fetchNextPage();
  }, [
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoaderInView,
    isRecentPostsLoading,
  ]);

  const posts = compact(recentPostsData?.pages?.map((page) => page)?.flat(2));
  const hasPosts = Boolean(
    recentPostsData && recentPostsData?.pages?.[0]?.length > 0
  );

  const pinnedPost = pinnedPostsData?.pages?.[0]?.[0];

  // useEffect(() => {
  //   if (query.id) {
  //     // @ts-ignore
  //     document.body.style.overflow = "hidden";
  //   } else {
  //     // @ts-ignore
  //     document.body.style.overflow = "auto";
  //   }
  // }, [query.id]);

  // useEffect(() => {
  //   const preventScroll = (e: any) => e.preventDefault();

  //   if (query.id) {
  //     document.addEventListener("touchmove", preventScroll, { passive: false });
  //   } else {
  //     document.removeEventListener("touchmove", preventScroll);
  //   }

  //   return () => {
  //     document.removeEventListener("touchmove", preventScroll);
  //   };
  // }, [query.id]);

  return (
    <Grid
      container
      rowSpacing={{ md: "24px", xs: "16px" }}
      className={styles.gridContainer}
      ref={gridRef}
    >
      {!hasPosts && !isRecentPostsLoading && (
        <Grid item xs={12}>
          <EmptySocialPost subtitle="Share your first post by selecting the blue button from the left menu" />
        </Grid>
      )}

      {((!hasPosts && isRecentPostsLoading) ||
        (!pinnedPost && isPinnedPostsLoading)) && (
        <Grid item xs={12}>
          {postLoader}
        </Grid>
      )}

      {pinnedPost && !isRecentPostsLoading && isFeed && (
        <Grid item xs={12}>
          <PostCard post={pinnedPost} isPinned />
        </Grid>
      )}

      {isFeed && pinnedPost && !isMobile && (
        <Grid item xs={12}>
          <MeetOtherTravellerCard />
        </Grid>
      )}

      {posts?.map((post, idx) => (
        <>
          <Grid item xs={12} key={post?.id}>
            <PostCard post={post} />
          </Grid>
          {/* {isFeed && pinnedPost && idx === 0 && (
            <Grid item xs={12}>
              <InstagramPostsCard />
            </Grid>
          )} */}
          {isFeed && !pinnedPost && idx === 0 && !isMobile && (
            <Grid item xs={12}>
              <MeetOtherTravellerCard />
            </Grid>
          )}
          {/* {isFeed && !pinnedPost && idx === 1 && (
            <Grid item xs={12}>
              <InstagramPostsCard />
            </Grid>
          )} */}
        </>
      ))}

      {hasPosts && (
        <Grid item xs={12}>
          {hasNextPage ? (
            <div ref={loaderContainerRef}>
              {isFetchingNextPage && postLoader}
            </div>
          ) : (
            <Typography
              color="text.secondary"
              textAlign="center"
              className={styles.listInfo}
            >
              You&apos;ve seen it all!
            </Typography>
          )}
        </Grid>
      )}

      {isPostDialogOpen && query.id && !isMobile && <PostDialog />}
      {isPostDialogOpen && query.id && isMobile && <MobilePostDialog />}
    </Grid>
  );
};

export default TimelineFeed;
